'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { NotificationTypes, KBArticles, KBArticleSections } from 'AdsUI/lib/Constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H5 from 'UIComponents/elements/headings/H5';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import KnowledgeBaseLink from 'AdsUI/components/KnowledgeBaseLink';
import { KNOWN_AUDIENCE_ERRORS } from 'AdsUI/lib/ActionNotificationHandlers';

const GoogleNotWhitelistedKBLink = ({
  children
}) => /*#__PURE__*/_jsx(KnowledgeBaseLink, {
  kbArticle: KBArticles.CREATE_AUDIENCES,
  kbSection: KBArticleSections.CREATE_AUDIENCES['CONTACT_LIST'],
  context: "google-not-whitelisted-error",
  children: children
});

const GoogleNotWhitelistedErrorInfo = ({
  accountName
}) => /*#__PURE__*/_jsx(FormattedJSXMessage, {
  message: "audiences.wizard.creationBanners.message.ADVERTISER_NOT_WHITELISTED_FOR_USING_UPLOADED_DATA_jsx",
  options: {
    accountName
  },
  elements: {
    Link: GoogleNotWhitelistedKBLink
  }
});

const ErrorInfo = ({
  error,
  accountName,
  network
}) => {
  if (error === KNOWN_AUDIENCE_ERRORS.SEED_AUDIENCE_TOO_SMALL) {
    return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `audiences.wizard.creationBanners.message.${network}.${error}`,
      options: {
        accountName
      }
    });
  }

  return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: `audiences.wizard.creationBanners.message.${error}`,
    options: {
      accountName
    }
  });
}; // When new audience errors are added here, make sure Workflows is also aware.
// See: https://git.hubteam.com/HubSpot/WorkflowsReactUI/blob/master/static/js/platform/action-features/ads-audience-membership/ads/AudienceCreationAlert.js#L14


const getAudienceErrorBody = (error, accountName, network) => ({
  SOURCE_IS_TOO_SMALL: /*#__PURE__*/_jsx(ErrorInfo, {
    error: error,
    accountName: accountName
  }),
  UNTRUSTWORTHY_PORTAL: /*#__PURE__*/_jsx(ErrorInfo, {
    error: error,
    accountName: accountName
  }),
  ADVERTISER_NOT_WHITELISTED_FOR_USING_UPLOADED_DATA: /*#__PURE__*/_jsx(GoogleNotWhitelistedErrorInfo, {
    accountName: accountName
  }),
  SEED_AUDIENCE_TOO_SMALL: /*#__PURE__*/_jsx(ErrorInfo, {
    error: error,
    accountName: accountName,
    network: network
  })
})[error];

const ErrorNotificationMessage = ({
  text,
  title
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx(H5, {
    className: "m-bottom-2",
    children: title
  }), /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("span", {
      children: text
    })
  })]
});

const getAudienceCreationError = ({
  network,
  error,
  adAccount
}) => {
  const titleKey = `audiences.wizard.creationBanners.title.${error}`;
  return {
    message: /*#__PURE__*/_jsx(ErrorNotificationMessage, {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: isValidI18nKey(titleKey) ? titleKey : 'audiences.wizard.creationBanners.title.default'
      }),
      text: getAudienceErrorBody(error, adAccount.getShortName(), network)
    }),
    type: NotificationTypes.DANGER.toLowerCase()
  };
};

export default getAudienceCreationError;